import React from "react";
import { Card, Typography } from "antd";

interface FeatureCardProps {
  imageSrc: string;
  title: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ imageSrc, title }) => {
  return (
    <Card
      cover={<img alt={title} src={imageSrc} className="feature-card-image" />}
      className="card-shadow text-center feature-card h-100 radius-12"
      classNames={{ body: "feature-card-body" }}
    >
      <Typography.Text className="color-2F3034 text-center ff-inter fs-20 fw-700">
        {title}
      </Typography.Text>
    </Card>
  );
};

export default FeatureCard;
